<template>
    <!-- 超额收益 -->
    <div class="excessReturn">
        <el-row class="row-one mt30">
            <span class="subtitle">超额收益率</span>
        </el-row>
        <el-form :model="cesyForm" class="form-one" :inline="true" label-position="right">
            <el-form-item label="选择时间：">
                <el-radio-group v-model="cesyForm.time" class="radio-btnt" value-key="id" @change="cesyTimeChnge($event,'time')">
                    <el-radio-button v-for="(item) in timeList" :key="item.id" :label="item">{{item.name}}</el-radio-button>
                </el-radio-group>
            </el-form-item>
            <el-form-item>
                <img src="@/assets/images/time.png" class="ml20" alt="" style="margin-right:10px;">
                <el-date-picker type="date" class="date-picker-two" :editable="false" placeholder="选择日期" v-model="cesyForm.startDate" :clearable="false" value-format="yyyy-MM-dd" @change="cesyTimeChnge"></el-date-picker> -
                <el-date-picker type="date" class="date-picker-two" :editable="false" placeholder="选择日期" v-model="cesyForm.endDate" :clearable="false" value-format="yyyy-MM-dd" @change="cesyTimeChnge"></el-date-picker>
            </el-form-item>
            <el-form-item label="比较基准：" class="ml20">
                <el-select v-model="cesyForm.bjjz" class="select-one" style="width:100px;" value-key="code" @change="getPrivateFundExcessReturnCharts()">
                    <el-option v-for="(item) in baseList" :key="item.code" :label="item.name" :value="item"></el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <div id="cesy1" style="width:1160px;height:400px;"></div>
        <div class="mt30">
            <div v-for="(item,i) in excessReturnRate" :key="i+'cesyl'">
                <ul class="row-h"><li v-for="(val1,i1) in item" :key="i1+'h'">{{val1.secuNameAbbr}}</li></ul>
                <ul class="row-b"><li v-for="(val2,v2) in item" :key="v2+'b'">{{val2.indexValue}}</li></ul>
            </div>
        </div>
        <div>
            <el-row class="row-one mt30">
                <span class="subtitle">超额胜率</span>
            </el-row>
            <el-form :model="zslForm" class="form-one" :inline="true" label-position="right">
                <el-form-item label="选择时间：">
                    <el-radio-group v-model="zslForm.time" class="radio-btnt" value-key="id" @change="zslTimeChnge($event,'time')">
                        <el-radio-button v-for="(item) in timeList" :key="item.id" :label="item">{{item.name}}</el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <el-form-item>
                    <img src="@/assets/images/time.png" class="ml20" alt="" style="margin-right:10px;">
                    <el-date-picker type="date" class="date-picker-two" :editable="false" placeholder="选择日期" v-model="zslForm.startDate" :clearable="false" value-format="yyyy-MM-dd" @change="zslTimeChnge"></el-date-picker> -
                    <el-date-picker type="date" class="date-picker-two" :editable="false" placeholder="选择日期" v-model="zslForm.endDate" :clearable="false" value-format="yyyy-MM-dd" @change="zslTimeChnge"></el-date-picker>
                </el-form-item>
                <el-form-item label="比较基准：" class="ml20">
                    <el-select v-model="zslForm.bjjz" class="select-one" style="width:100px;" value-key="code" @change="getPrivateFundExcessWinRateCharts()">
                        <el-option v-for="(item) in baseList" :key="item.code" :label="item.name" :value="item"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div id="cesl" style="width:1160px;height: 400px;"></div>
            <div class="excessReturn-card mt20">
                <div class="excessReturn-card-left">
                    <el-row class="row-two mt20">
                        <h3 class="title">周胜率</h3>
                    </el-row>
                    <div id="zsl" style="width:560px;height:260px;"></div>
                </div>
                <div class="excessReturn-card-right">
                    <el-row class="row-two mt20">
                        <h3 class="title">月胜率</h3>
                    </el-row>
                    <div id="ysl" style="width:560px;height:260px;"></div>
                </div>
            </div>
        </div>
        <!-- 超额稳定性 -->
        <el-row class="row-one mt30">
            <span class="subtitle">区间超额统计</span>
        </el-row>
        <el-row>
            <el-form :model="cezbForm" :inline="true" class="form-one" label-width="90px" label-position="left" style="display:inline-block;">
                <el-form-item label="展现形式：" style="margin-right:25px;">
                    <el-radio-group v-model="cezbForm.show" class="radio-btnt padd">
                        <el-radio-button label="表"></el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="比较基准：">
                    <el-select v-model="cezbForm.bjjz" class="select-one" style="width:100px;" value-key="code" @change="getPrivateFundExcessIndex">
                        <el-option v-for="(item) in baseList" :key="item.code" :label="item.name" :value="item"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <el-radio-group class="radio-btns fr mt5" v-model="qjceRadio" @change="getPrivateFundExcessIndex">
                <el-radio-button label="阶段"></el-radio-button>
                <el-radio-button label="年度"></el-radio-button>
            </el-radio-group>
        </el-row>
        <el-table :data="cezbData" class="table-one mt20 mb40" border>
            <el-table-column prop="name"></el-table-column>
            <el-table-column v-for="(item,i) in cezbDataX" :key="i" :label="String(cezbDataX[i])">
                <template slot-scope="scope"><span :class="[{'rColor':parseFloat(scope.row.data[i])>0},{'gColor':parseFloat(scope.row.data[i])<0}]">{{scope.row.data[i]}}</span></template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
export default {
    name: "excessReturn",
    props: ['InnerCode','innerIs'],
    data() {
        return {
            timeList:[],
            baseList:[],
            zslForm: {// 周胜率
                time: '',
                startDate: '',
                endDate: '',
                bjjz: '',
            },
            cesyForm: {// 超额收益率
                time: '',
                startDate: '',
                endDate: '',
                bjjz: '',
            },
            excessReturnRate: [],
            // 超额稳定性
            cezbForm:{bjjz:'',show:'表'},
            cezbData:[],
            cezbDataX:[],
            qjceRadio: '阶段',
        }
    },
    mounted() {
        this.getPrivateFundDatePhase();
        this.getPrivateFundExcessReturnCharts();
        this.getPrivateFundExcessIndex();
    },
    methods: {
        getPrivateFundDatePhase(){
            const vm=this;
            vm.$http.post(vm.innerIs? vm.$apiPath.getInnerFundDatePhase : vm.$apiPath.getPrivateFundDatePhase,{
                InnerCode:vm.InnerCode
            }).then(res=>{
                // console.log(res);
                if(res.data.code==200){
                    let sdata=res.data.data;
                    sdata.baseList.forEach((val,ind)=>{
                        vm.baseList.push({
                            name:val.name,
                            code:val.value
                        })
                    })
                    if(sdata.regionList && sdata.regionList.length>0){
                        sdata.regionList.forEach((val,ind)=>{
                            vm.timeList.push({
                                id:ind,
                                name:val.region,
                                start:val.startDate,
                                end:val.endDate
                            })
                        })
                    }
                    // 初始化
                    vm.cezbForm.bjjz=vm.baseList[0];
                    this.initial(vm.zslForm,vm.baseList[0],vm.timeList[0],'cesl')
                    this.initial(vm.cesyForm,vm.baseList[0],vm.timeList[0],'cesy1')
                }
            })
        },
        initial(form,base,time,type) {
            form.bjjz=base;
            form.time = time
            form.startDate = time.start
            form.endDate = time.end
            if(type == 'cesl') {
                this.getPrivateFundExcessWinRateCharts()
            } else if(type == 'cesy1') {
                this.getPrivateFundExcessReturnCharts()
            }
        },
        // 超额胜率
        getPrivateFundExcessWinRateCharts() {
            let vm = this
            vm.$http.post(vm.$apiPath.GetPrivateFundExcessYieldCharts, {
                InnerCode: vm.InnerCode,
                StartDate: vm.zslForm.startDate,
                EndDate: vm.zslForm.endDate,
                BaseCode: vm.zslForm.bjjz.code,
            }).then(res => {
                // console.log(res);
                if(res.data.code == 200) {
                    let xdata = res.data.data
                    let seriesData = []
                    let seriesDataPie1 = [{
                        name: '',
                        type: 'pie',
                        radius: '65%',
                        center: ['40%', '50%'], //饼图的位置
                        label: { //饼图图形上的文本标签
                            normal: {
                                show: true,
                                textStyle:{fontSize: 14,fontWeight:500},
                                formatter: '{d}%'
                            }
                        },
                        itemStyle:{borderColor:'#fff',borderWidth:2},
                        data:[]
                    }]
                    let seriesDataPie2 = [{
                        name: '',
                        type: 'pie',
                        radius: '65%',
                        center: ['40%', '50%'], //饼图的位置
                        label: { //饼图图形上的文本标签
                            normal: {
                                show: true,
                                textStyle:{fontSize: 14,fontWeight:500},
                                formatter: '{d}%'
                            }
                        },
                        itemStyle:{borderColor:'#fff',borderWidth:2},
                        data:[]
                    }]
                    xdata.nameList.forEach((item,i) => {
                        seriesData.push({
                            name:item,
                            type:'bar',barMaxWidth: 20,
                            data:xdata.dataList[i],
                        })
                    });
                    xdata.indexList[0].forEach((val1,v1) => {
                        seriesDataPie1[0].data.push({
                            name:val1.secuNameAbbr,
                            value:val1.ratio,
                            label:{
                                normal:{
                                    position:'outside',
                                    textStyle:{color:'inherit'}
                                }
                            }
                        })
                    })
                    xdata.indexList[1].forEach((val2,v1) => {
                        seriesDataPie2[0].data.push({
                            name:val2.secuNameAbbr,
                            value:val2.ratio,
                            label:{
                                normal:{
                                    position:'outside',
                                    textStyle:{color:'inherit'}
                                }
                            }
                        })
                    })
                    
                    this.$commonEcharts.echartsSix('cesl',xdata.dateList,seriesData,true,['#4472c4'],true)
                    this.$commonEcharts.echartsNormalPie('zsl',seriesDataPie1,'20px',['#4472c4','#ed7d31'])
                    this.$commonEcharts.echartsNormalPie('ysl',seriesDataPie2,'20px',['#4472c4','#ed7d31'])
                }
            }).catch(err => { })
        },
        zslTimeChnge(val,type) {
            if(type == 'time') {
                this.zslForm.startDate = val.start
                this.zslForm.endDate = val.end
            } else {
                this.zslForm.time = ''
            }
            this.getPrivateFundExcessWinRateCharts();
        },
        // 超额收益率
        getPrivateFundExcessReturnCharts() {
            let vm = this
            vm.$http.post(vm.$apiPath.GetPrivateFundExcessReturnCharts, {
                InnerCode: vm.InnerCode,
                StartDate: vm.cesyForm.startDate,
                EndDate: vm.cesyForm.endDate,
                BaseCode: vm.cesyForm.bjjz.code,
            }).then(res => {
                // console.log(res);
                if(res.data.code == 200) {
                    let xdata = res.data.data
                    let seriesData = []
                    xdata.nameList.forEach((item,i) => {
                        seriesData.push({
                            name:item,
                            type:'line',symbol:'circle',showSymbol: false,symbolSize:8,
                            data: xdata.dataList[i]
                        })
                    });
                    vm.$commonEcharts.echartsSix('cesy1',xdata.dateList,seriesData,true)
                }
                
            }).catch(err => { })
            // 基金阶段迢额指标
            vm.$http.post(vm.$apiPath.GetPrivateFundExcessIndexCharts, {
                InnerCode: vm.InnerCode,
                StartDate: vm.cesyForm.startDate,
                EndDate: vm.cesyForm.endDate,
                BaseCode: vm.cesyForm.bjjz.code,
            }).then(res => {
                // console.log(res);
                if(res.data.code == 200) {
                    let list = res.data.data.dataList
                    let newList = new Array()
                    for(let i = 0; i < list.length / 4; i++) {
                        newList[i] = list.slice(i * 9, (i + 1) * 9)
                    }
                    vm.excessReturnRate = newList
                }
            }).catch(err => { })
        },
        cesyTimeChnge(val,type) {
            if(type == 'time') {
                this.cesyForm.startDate = val.start
                this.cesyForm.endDate = val.end
            } else {
                this.cesyForm.time = ''
            }
            this.getPrivateFundExcessReturnCharts();
        },
        // 超额稳定性
        getPrivateFundExcessIndex() {
            let vm = this
            vm.$http.post(vm.$apiPath.GetPrivateFundExcessIndex, {
                InnerCode: vm.InnerCode,
                BaseCode: vm.cezbForm.bjjz.code,
            }).then(res => {
                // console.log(res);
                let xdata = res.data.data
                if(res.data.code == 200) {
                    let num=0;
                    for(let i=0;i<xdata.dateList.length;i++){
                        if(xdata.dateList[i].length!=5){
                            num++;
                        }else{
                            break;
                        }
                    }
                    let seriesData=[];
                    xdata.nameList.forEach((val,ind)=>{
                        seriesData.push({
                            name: val,
                            data: vm.qjceRadio == '阶段' ? xdata.dataList[ind].slice(0,num) : xdata.dataList[ind].slice(num)
                        })
                    })
                    vm.cezbDataX = vm.qjceRadio == '阶段' ? xdata.dateList.slice(0,num) : xdata.dateList.slice(num)
                    vm.cezbData = seriesData;
                }
            }).catch(err => { })
        },
        
    }
}
</script>

<style lang="less" scoped>
.excessReturn {
    .row-h {
        height: 40px;background: @tableHeaderColor;line-height: 40px;font-size:18px;
        li {float: left;width: 25%;text-align: center;position: relative;}
        li::before {content: "";position: absolute;top: 50%;transform: translateY(-50%);right: 0;width: 1px;height: 24px;background: @colorD5;}
        li:last-child::before {display: none;}
    }
    .row-b {
        height: 66px;line-height: 66px;font-size:24px;
        li {float: left;width: 25%;text-align: center;color: @mainColor;}
    }
    &-card{
        width:100%;display: flex;
        &-left {position: relative;width:50%;height:100%;padding-right:20px;}
        &-left::after {content: "";width: 2px;height: 90%;background: @cardTitBg;position: absolute;right: 0;top: 50%;transform: translateY(-50%);}
        &-right{width:50%;height:100%;padding-left:20px;}
    }
}
</style>